"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var resources_1 = require("./resources");
var defaults_1 = require("./defaults");
var resource_1 = require("./resources/resource");
var bzClient = /** @class */ (function () {
    function bzClient(config) {
        this.user = { login: '', email: '' };
        this.defaults = resource_1.resource.axios.defaults;
        this.bugs = new resources_1.bug();
        this.users = new resources_1.user();
        this.products = new resources_1.product();
        if (config)
            this.setConfig(config);
    }
    bzClient.prototype.setConfig = function (config) {
        // merge defaults with supplied to account for missing fields in custom configs.
        config = Object.assign(defaults_1.DEFAULT_CONFIG, config);
        if (config.url)
            this.baseUrl = config.url;
        this.url = "" + this.baseUrl + config.api_extention;
        if (config.apiKey)
            this.setApiKey(config.apiKey);
        resource_1.resource.axios.defaults.baseURL = this.url;
    };
    bzClient.prototype.setApiKey = function (apiKey) {
        this.user.apiKey = apiKey;
        resource_1.resource.axios.defaults.params = { api_key: this.user.apiKey };
    };
    bzClient.prototype.whoami = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.users.whoami()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            result.apiKey = this.user.apiKey;
                            this.setUser(result);
                            return [2 /*return*/, this.user];
                        }
                        throw new Error('Error retrieving whoami data');
                }
            });
        });
    };
    bzClient.prototype.setUser = function (user) {
        this.user = user;
    };
    bzClient.prototype.createClient = function (config) {
        var defaultInstance = new bzClient(Object.assign(defaults_1.DEFAULT_CONFIG, config));
        return defaultInstance;
    };
    return bzClient;
}());
exports.bzClient = bzClient;



//////////////////
// WEBPACK FOOTER
// ../node_modules/bzrest/lib/client.js
// module id = 959
// module chunks = 0